import { TenantEntity } from '../TenantEntity'

export class InsureInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get insuranceType() {
    return this._data.insuranceType
  }
  set insuranceType(insuranceType) {
    this._data.insuranceType = insuranceType
  }
  get insuredIdx() {
    return this._data.insuredIdx
  }
  set insuredIdx(insuredIdx) {
    this._data.insuredIdx = insuredIdx
  }
  get insuredName() {
    return this._data.insuredName
  }
  set insuredName(insuredName) {
    this._data.insuredName = insuredName
  }
  get insuranceAgent() {
    return this._data.insuranceAgent
  }
  set insuranceAgent(insuranceAgent) {
    this._data.insuranceAgent = insuranceAgent
  }
  get insuranceCompany() {
    return this._data.insuranceCompany
  }
  set insuranceCompany(insuranceCompany) {
    this._data.insuranceCompany = insuranceCompany
  }
  get insureNo() {
    return this._data.insureNo
  }
  set insureNo(insureNo) {
    this._data.insureNo = insureNo
  }
  get policyNo() {
    return this._data.policyNo
  }
  set policyNo(policyNo) {
    this._data.policyNo = policyNo
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
  get invoiceAmount() {
    return this._data.invoiceAmount
  }
  set invoiceAmount(invoiceAmount) {
    this._data.invoiceAmount = invoiceAmount
  }
  get invoiceCurrency() {
    return this._data.invoiceCurrency
  }
  set invoiceCurrency(invoiceCurrency) {
    this._data.invoiceCurrency = invoiceCurrency
  }
  get insuranceAmount() {
    return this._data.insuranceAmount
  }
  set insuranceAmount(insuranceAmount) {
    this._data.insuranceAmount = insuranceAmount
  }
  get insuranceCurrency() {
    return this._data.insuranceCurrency
  }
  set insuranceCurrency(insuranceCurrency) {
    this._data.insuranceCurrency = insuranceCurrency
  }
  get premium() {
    return this._data.premium
  }
  set premium(premium) {
    this._data.premium = premium
  }
  get premiumCurrency() {
    return this._data.premiumCurrency
  }
  set premiumCurrency(premiumCurrency) {
    this._data.premiumCurrency = premiumCurrency
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.jobUuid = rate
  }
  get submitDate() {
    return this._data.submitDate
  }
  set submitDate(submitDate) {
    this._data.submitDate = submitDate
  }
  get issuingTime() {
    return this._data.issuingTime
  }
  set issuingTime(issuingTime) {
    this._data.issuingTime = issuingTime
  }
  get issuingState() {
    return this._data.issuingState
  }
  set issuingState(issuingState) {
    this._data.issuingState = issuingState
  }
  get departureStartDate() {
    return this._data.departureStartDate
  }
  set departureStartDate(departureStartDate) {
    this._data.departureStartDate = departureStartDate
  }
  get portLoading() {
    return this._data.portLoading
  }
  set portLoading(portLoading) {
    this._data.portLoading = portLoading
  }
  get destination() {
    return this._data.destination
  }
  set destination(destination) {
    this._data.destination = destination
  }
  get billno() {
    return this._data.billno
  }
  set billno(billno) {
    this._data.billno = billno
  }
  get waybillno() {
    return this._data.waybillno
  }
  set waybillno(waybillno) {
    this._data.waybillno = waybillno
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get insuranceDate() {
    return this._data.insuranceDate
  }
  set insuranceDate(insuranceDate) {
    this._data.insuranceDate = insuranceDate
  }
  get finInsuranceDate() {
    return this._data.finInsuranceDate
  }
  set finInsuranceDate(finInsuranceDate) {
    this._data.finInsuranceDate = finInsuranceDate
  }
  get insureOrderUser() {
    return this._data.insureOrderUser
  }
  set insureOrderUser(insureOrderUser) {
    this._data.insureOrderUser = insureOrderUser
  }
  get policyUser() {
    return this._data.policyUser
  }
  set policyUser(policyUser) {
    this._data.policyUser = policyUser
  }
  get reconciliationUser() {
    return this._data.reconciliationUser
  }
  set reconciliationUser(reconciliationUser) {
    this._data.reconciliationUser = reconciliationUser
  }
  get policySyncStatus() {
    return this._data.policySyncStatus
  }
  set policySyncStatus(policySyncStatus) {
    this._data.policySyncStatus = policySyncStatus
  }
  get premiumSyncStatus() {
    return this._data.premiumSyncStatus
  }
  set premiumSyncStatus(premiumSyncStatus) {
    this._data.premiumSyncStatus = premiumSyncStatus
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get questionnaireStatus() {
    return this._data.questionnaireStatus
  }
  set questionnaireStatus(questionnaireStatus) {
    this._data.questionnaireStatus = questionnaireStatus
  }
  get supplierResponse() {
    return this._data.supplierResponse
  }
  set supplierResponse(supplierResponse) {
    this._data.supplierResponse = supplierResponse
  }
  get contactInformation() {
    return this._data.contactInformation
  }
  set contactInformation(contactInformation) {
    this._data.contactInformation = contactInformation
  }
  get insureType() {
    return this._data.insureType
  }
  set insureType(insureType) {
    this._data.insureType = insureType
  }
  get insureLink() {
    return this._data.insureLink
  }
  set insureLink(insureLink) {
    this._data.insureLink = insureLink
  }
  get insuranceLink() {
    return this._data.insuranceLink
  }
  set insuranceLink(insuranceLink) {
    this._data.insuranceLink = insuranceLink
  }
  get insuranceDocument() {
    return this._data.insuranceDocument
  }
  set insuranceDocument(insuranceDocument) {
    this._data.insuranceDocument = insuranceDocument
  }
  get invoiceLink() {
    return this._data.invoiceLink
  }
  set invoiceLink(invoiceLink) {
    this._data.invoiceLink = invoiceLink
  }
  get insuranceFileId() {
    return this._data.insuranceFileId
  }
  set insuranceFileId(insuranceFileId) {
    this._data.insuranceFileId = insuranceFileId
  }
  get invoiceFileId() {
    return this._data.invoiceFileId
  }
  set invoiceFileId(invoiceFileId) {
    this._data.invoiceFileId = invoiceFileId
  }
  get contactUser() {
    return this._data.contactUser
  }
  set contactUser(contactUser) {
    this._data.contactUser = contactUser
  }
  get contactTel() {
    return this._data.contactTel
  }
  set contactTel(contactTel) {
    this._data.contactTel = contactTel
  }
  get contactAddress() {
    return this._data.contactAddress
  }
  set contactAddress(contactAddress) {
    this._data.contactAddress = contactAddress
  }
  get registeredIdx() {
    return this._data.registeredIdx
  }
  set registeredIdx(registeredName) {
    this._data.registeredIdx = registeredName
  }
  get registeredName() {
    return this._data.registeredName
  }
  set registeredName(registeredIdx) {
    this._data.registeredName = registeredIdx
  }
  get registeredAddress() {
    return this._data.registeredAddress
  }
  set registeredAddress(registeredAddress) {
    this._data.registeredAddress = registeredAddress
  }
  get businessName() {
    return this._data.businessName
  }
  set businessName(businessName) {
    this._data.businessName = businessName
  }
  get businessAddress() {
    return this._data.businessAddress
  }
  set businessAddress(businessAddress) {
    this._data.businessAddress = businessAddress
  }
}
